<template>
  <div>
    <el-row>
      <el-col :span="3" :offset="3">
        <h2 style="color: green" @click="goDown">写作技巧技术分享</h2>
      </el-col>
      <el-col :span="5" >
        <el-link style="margin: 26px 0px" @click.native="goDown">首页</el-link>
        <el-link style="margin: 26px 16px">问答</el-link>
        <el-link style="margin: 26px 0px">专栏</el-link>
        <el-link style="margin: 26px 16px">课程</el-link>
        <el-link style="margin: 26px 0px">招聘</el-link>
        <el-link style="margin: 26px 16px">活动</el-link>
        <el-link style="margin: 26px 0px">发现</el-link>
      </el-col>

      <el-col :span="5" >
        <el-input placeholder="搜索关键字"  style="margin: 18px 0px">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-col>

      <el-col :span="5" v-if="$store.state.name" style="margin: 20px">
        <el-link icon="el-icon-user-solid">{{ $store.state.name }}</el-link>
        <!--         <el-link type="danger" @click="signOut">&nbsp;&nbsp退出</el-link>-->
        <el-button type="danger"  size="mini" style="margin-left:  10px" @click="signOut">退出</el-button>

      </el-col>
      <el-col :span="5" v-else >
        <el-button type="success" size="mini" style="margin: 22px 10px" @click="signInDialogVisible=true" >登录</el-button>
        <el-button  size="mini" style="margin: 18px 0" @click="signUpDialogVisible=true">注册</el-button>
      </el-col>

      <el-dialog
          title="注册账号"
          :visible.sync="signUpDialogVisible"
          width="25%"
          center
          close-on-click-modal
      >
        <el-form :model="signUpForm" label-position="top" :rules="rules" ref="signUpForm" >
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="signUpForm.phone" autocomplete="off" prefix-icon="el-icon-phone-outline"
                      placeholder="为方便记忆，请使用手机号"></el-input>
          </el-form-item>

          <el-form-item label="昵称" prop="name">
            <el-input v-model="signUpForm.name" autocomplete="off" prefix-icon="el-icon-user"
                      placeholder="请输入昵称"></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="pwd" >

            <el-input v-model="signUpForm.pwd" autocomplete="off" prefix-icon="el-icon-lock"
                      placeholder="请输入密码"></el-input>

          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="danger" @click="signUp('signUpForm')" round >立即注册</el-button>
        </div>
      </el-dialog>

      <el-dialog
          title="登录"
          :visible.sync="signInDialogVisible"
          width="25%"
          center
          close-on-click-modal
      >
        <el-form :model="signInForm" label-position="top" :rules="rules" ref="signInForm" >
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="signInForm.phone" autocomplete="off" prefix-icon="el-icon-phone-outline"
                      placeholder="请输入手机号"></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="pwd" >
            <el-input v-model="signInForm.pwd" autocomplete="off" prefix-icon="el-icon-lock"
                      placeholder="请输入密码"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="danger" @click="signIn('signInForm')" round >立即登录</el-button>
        </div>
      </el-dialog>
    </el-row>
    <router-view></router-view>
    <div style="margin: 30px auto;width: 570px">
      写作技巧技术分享 版权所有 ©www.inklw.com | <a href="https://beian.miit.gov.cn/" style="text-decoration: none;">鄂ICP备2024059821号-1</a>
    </div>

  </div>
</template>

<script>
import http from '../utils/http-base'
export default {
  name: "index",
  data() {
    return {
      message: '我是page-a',
      signInDialogVisible: false,
      signUpDialogVisible: false,
      signUpForm: {
        phone: "",
        name: '',
        pwd: ""
      },
      signInForm: {
        phone: "",
        name: '',
        pwd: ""
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { len:11, message: '请输入正确格式的手机号', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 10, message: '长度在 6 到 10 个字符', trigger: 'blur' }
        ],

      },
    }
  },
  methods: {
    goDown(){
      this.$router.push({
        name:'index2',
      }).catch(()=>{})

    },
    // 登入
    signInTry() {
      this.signInDialogVisible = true
    },
    // 注册
    signUpTry() {
      this.signUpDialogVisible = true
    },

    signUp(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          http.post("/api/login/up", {
            name:this.signUpForm.name,
            pwd: this.signUpForm.pwd,
            phone: this.signUpForm.phone,
          }).then(res=>{
            if (res.data.code ===0){
              this.$message({
                message: '恭喜你，注册成功',
                type: 'success'
              });
              this.signUpDialogVisible = false
              this.$store.state.name=res.data.msg.Name
              this.signUpForm={
                phone: "",
                name: '',
                pwd: ""
              }
            }else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    signIn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          http.post("/api/login/in", {
            pwd: this.signInForm.pwd,
            phone: this.signInForm.phone,
          },).then(res=>{
            if (res.data.code ===0){
              this.$message({
                message: '登录成功!',
                type: 'success'
              });
              this.$store.state.name=res.data.msg.Name
              this.signInDialogVisible = false

            }else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    checkLogin() {

      http.get("/api/login/").then(res=>{
        if (res.data.code ===0){
          this.$store.state.name=res.data.data.Name
          this.signInDialogVisible = false
        }
      })
    },
    signOut(){
      http.get("/api/login/out").then(res=>{
        if (res.data.code ===0){
          this.$store.state.name=null;
          this.$message({message: '退出成功!', type: 'success'  });
        }
      })
    },
  },
  mounted() {
    // 页面打开时需要执行的操作
    this.checkLogin();
  },

}
</script>

<style scoped>

</style>